(function () {
  if (customElements.get('about-us-faq')) return;

  customElements.define(
    'about-us-faq',
    class AboutUsFaq extends HTMLElement {
      connectedCallback() {
        this.querySelectorAll('[data-faq-item]').forEach((item) => {
          const trigger = item.querySelector('[data-faq-trigger]');
          if (!trigger) return;

          trigger.addEventListener('click', () => {
            const isOpen = item.classList.toggle('is-open');
            trigger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
          });
        });
      }
    }
  );
})();
